<app-login-card>
  @switch (state) {
    @case (ConsentState.failed) {
      <div class="row form-row">
        <div class="col-md-12">
          <h1 #heading class="text-center" tabindex="-1">{{ 'oauth_consent_failed_heading' | translate }}</h1>
        </div>
      </div>
      <div class="row form-row">
        <div class="col-12">
          <ds-banner [state]="DsBannerState.error" data-test-id="oauth-consent-error">
            <div ds-banner-body>{{ errorKey | translate }}</div>
          </ds-banner>
        </div>
      </div>
      @if (canRetry) {
        <div class="row margin-bottom">
          <div class="col-12 d-flex justify-content-end">
            <button
              ds-button
              type="button"
              [variant]="DsButtonVariants.secondary"
              (click)="retry()"
              data-test-id="oauth-consent-retry-btn"
            >
              {{ 'try_again' | translate }}
            </button>
          </div>
        </div>
      }
    }
    @case (ConsentState.loading) {
      <div class="d-flex justify-content-center py-5" role="status" aria-live="polite" data-test-id="oauth-consent-loading">
        <ds-loading-spinner
          [size]="DsLoadingSpinnerSize.Large"
          [variant]="DsLoadingSpinnerVariant.Gray"
          [label]="'label_loading' | translate"
        ></ds-loading-spinner>
      </div>
    }
    @case (ConsentState.continuing) {
      <div class="d-flex justify-content-center py-5" role="status" aria-live="polite" data-test-id="oauth-consent-continuing">
        <ds-loading-spinner
          [size]="DsLoadingSpinnerSize.Large"
          [variant]="DsLoadingSpinnerVariant.Gray"
          [label]="'oauth_consent_continuing' | translate"
        ></ds-loading-spinner>
      </div>
    }
    @default {
      @if (details) {
        <div class="row form-row">
          <div class="col-md-12">
            <h1 #heading class="text-center" tabindex="-1" data-test-id="oauth-consent-heading">
              {{ 'oauth_consent_heading' | translate: details.clientName }}
            </h1>
          </div>
        </div>
        @if (details.redirectsToLocalhost) {
          <div class="row form-row">
            <div class="col-12">
              <ds-banner [state]="DsBannerState.warning" data-test-id="oauth-consent-localhost-warning">
                <div ds-banner-body>{{ 'oauth_consent_localhost_warning' | translate }}</div>
              </ds-banner>
            </div>
          </div>
        }
        <dl class="row form-row" data-test-id="oauth-consent-details">
          <dt class="col-sm-4">{{ 'organization' | translate }}</dt>
          <dd class="col-sm-8" data-test-id="oauth-consent-organization">{{ details.tenantName }}</dd>
          <dt class="col-sm-4">{{ 'oauth_consent_application_label' | translate }}</dt>
          <dd class="col-sm-8" data-test-id="oauth-consent-application">{{ details.clientName }}</dd>
          <dt class="col-sm-4">{{ 'oauth_consent_returns_to_label' | translate }}</dt>
          <dd class="col-sm-8" data-test-id="oauth-consent-returns-to">{{ details.redirectHost }}</dd>
        </dl>
        <div class="row form-row">
          <div class="col-12">
            <p data-test-id="oauth-consent-access-description">
              {{ 'oauth_consent_access_description' | translate: [details.clientName, details.tenantName] }}
            </p>
            <p data-test-id="oauth-consent-started-notice">{{ 'oauth_consent_started_notice' | translate }}</p>
            <p>
              {{ 'oauth_consent_docs_before' | translate }}
              <ds-link
                [external]="true"
                [href]="docsUrl"
                [title]="'opens_in_new_tab_label' | translate"
                data-test-id="oauth-consent-docs-link"
                >{{ 'oauth_consent_docs_link' | translate }}</ds-link
              >
              {{ 'oauth_consent_docs_after' | translate }}
            </p>
          </div>
        </div>
        @if (actionErrorKey) {
          <div #actionError class="row form-row" tabindex="-1">
            <div class="col-12">
              <ds-banner [state]="DsBannerState.error" data-test-id="oauth-consent-action-error">
                <div ds-banner-body>{{ actionErrorKey | translate }}</div>
              </ds-banner>
            </div>
          </div>
        }
        <div class="row form-row" role="status" aria-live="polite">
          <div class="col-12">
            @if (isDeciding) {
              <p data-test-id="oauth-consent-deciding">{{ 'oauth_consent_continuing' | translate }}</p>
            }
          </div>
        </div>
        <div class="row margin-bottom">
          <div class="col-12 d-flex justify-content-end gap-3" data-test-id="oauth-consent-buttons">
            <button
              ds-button
              type="button"
              [variant]="DsButtonVariants.secondary"
              [attr.aria-disabled]="isDeciding"
              (click)="deny()"
              data-test-id="oauth-consent-deny-btn"
            >
              {{ 'oauth_consent_deny' | translate }}
            </button>
            <button
              ds-button
              type="button"
              [variant]="DsButtonVariants.primary"
              [attr.aria-disabled]="isDeciding"
              (click)="allow()"
              data-test-id="oauth-consent-allow-btn"
            >
              {{ 'oauth_consent_allow' | translate }}
            </button>
          </div>
        </div>
      }
    }
  }
</app-login-card>
